import { Alert } from '@mui/material';
import { DEFAULT_LINK_BUTTON_STYLE } from '../../../../utils/styleHelpers';

export interface IncompleteSuppliersWarningProps {
  names: string[];
  onGoToCurrentSuppliers?: () => void;
}

/** One warning per current supplier whose spend isn't counted yet, with a way back to finish it. */
export const IncompleteSuppliersWarning = ({ names, onGoToCurrentSuppliers }: IncompleteSuppliersWarningProps) => (
  <>
    {names.map((name, index) => (
      <Alert
        key={`${index}-${name}`}
        severity="warning"
        sx={{ alignItems: 'center', '& .MuiAlert-action': { pt: 0 } }}
        action={
          onGoToCurrentSuppliers && (
            <button
              type="button"
              className={`${DEFAULT_LINK_BUTTON_STYLE} whitespace-nowrap`}
              onClick={onGoToCurrentSuppliers}>
              Go to Current Suppliers →
            </button>
          )
        }>
        {`${name} isn't included yet — complete its entry in Current Suppliers to update this value.`}
      </Alert>
    ))}
  </>
);
